<script>
  export default {
    name: 'submission-wizard',
    props: ['activeStep', 'mainEvent', 'event', 'paperType']
  }
</script>

<template>
    <div>
        <h1 class="title-steps">Submissão</h1>
        <div v-if="event && paperType" class="event-breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item><strong>{{mainEvent.title}}</strong></el-breadcrumb-item>
                <el-breadcrumb-item>{{event.title}}</el-breadcrumb-item>
                <el-breadcrumb-item><span class="paper-type">{{paperType.name}}</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="wizard">
            <div class="line"></div>
            <div class="item" v-bind:class="{'-active': activeStep === 'home'}">
                <i class="fa fa-files-o"></i>
                <span>Dados do Evento</span>
            </div>
            <div class="line"></div>
            <div class="item" v-bind:class="{'-active': activeStep === 'contents'}">
                <i class="fa fa-file-text"></i>
                <span>Dados do Trabalho</span>
            </div>
            <div class="line"></div>
            <div class="item" v-bind:class="{'-active': activeStep === 'authors'}">
                <i class="fa fa-users"></i>
                <span>Autores</span>
            </div>
            <div class="line"></div>
            <div class="item" v-bind:class="{'-active': activeStep === 'confirmation'}">
                <i class="fa fa-check"></i>
                <span>Confirmação</span>
            </div>
            <div class="line"></div>
        </div>
    </div>
</template>

<style lang="scss">
    .event-breadcrumb {
        margin: 0 auto;
        text-align: center;
        padding: 20px 0 10px;
        .el-breadcrumb {
            display: inline-block;
            .el-breadcrumb__item {
                font-size: 18px;
                line-height: 26px;
                text-align: left;
            }
            .paper-type {
                color: #838383;
            }
        }
    }
</style>
